import { render, staticRenderFns } from "./procedure-card.vue?vue&type=template&id=19d97158&"
import script from "./procedure-card.vue?vue&type=script&lang=js&"
export * from "./procedure-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports